<!-- ══════════════════════════════════════════════════════
     ASSESSMENT LANDING — assessment-landing.component.html
     Prefix: al-   |  No orange   |  Sehyog sh- token colours
     REBUILD v2: hero swapped for a real UI mockup graphic (no stock
     photo), a pain-point list panel, and small mockup graphics
     inside the card grids — all built from CSS, same bound data.
══════════════════════════════════════════════════════ -->

<!-- ══ HERO — 3-column desktop: [Mockup | Copy | Form] ══ -->
<section class="al-hero">
  <div class="al-hero-inner">

    <!-- COL 2: Headline + copy -->
    <div class="al-hero-copy">

      <div class="al-hero-badge-new">
        <span class="al-badge-dot"></span> New for 2026/27 &nbsp;·&nbsp; Years 3–11
      </div>

      <h1 class="al-h1">
        Unlock Your Child's<br/>
        <span class="al-h1-hi">Full Potential</span>
        Years 3 to 11
      </h1>

      <p class="al-hero-sub">
        Every child has potential. We help them discover it — a structured
        assessment that reveals not just what your child knows, but how
        they think, learn, and solve problems.
      </p>

      <div class="al-hero-cta-row">
        <button class="al-btn-hero-primary" (click)="scrollToRegister()">Register Free Assessment →</button>
        <a class="al-btn-hero-ghost" href="#al-how-it-works">See How It Works</a>
      </div>

      <div class="al-rar-inline">
        <span class="al-rar-dot-sm"></span>
        <span>Includes a full
          <strong>Digital Performance Report &amp; 1-to-1 Parent Consultation</strong>
        </span>
      </div>
    </div>

    <!-- COL 3: Registration form -->
    <div id="al-register" class="al-form-wrap">

      <div class="al-form-decor">
        <span class="al-decor-check">✓</span>
        <span><strong>4,800+</strong> families already registered</span>
      </div>

      <div class="al-form-card">

        <div class="al-form-success" *ngIf="formSubmitted">
          <div class="al-success-icon">✓</div>
          <h3>You're Registered!</h3>
          <p>Check your inbox for confirmation details and your consultation invite.</p>
        </div>

        <ng-container *ngIf="!formSubmitted">
          <h3 class="al-form-title">Book a Thinking Challenge Assessment</h3>
          <p class="al-form-sub">Free to enter. Expert-marked. Takes 90 seconds to register.</p>

          <div class="al-field">
            <input class="al-input" type="text" placeholder="Parent's Full Name" [(ngModel)]="form.parentName" />
          </div>
          <div class="al-field">
            <input class="al-input" type="email" placeholder="Email Address" [(ngModel)]="form.email" />
          </div>
          <div class="al-field">
            <input class="al-input" type="tel" placeholder="Phone Number (incl. country code)" [(ngModel)]="form.phone" />
          </div>
          <div class="al-field">
            <select class="al-select" [(ngModel)]="form.yearGroup">
              <option value="">Child's Current School Year</option>
              <option value="Year 3">Year 3</option>
              <option value="Year 4">Year 4</option>
              <option value="Year 5">Year 5</option>
              <option value="Year 6">Year 6</option>
              <option value="Year 7">Year 7</option>
              <option value="Year 8">Year 8</option>
              <option value="Year 9">Year 9</option>
              <option value="Year 10">Year 10</option>
              <option value="Year 11">Year 11</option>
            </select>
          </div>

          <div class="al-form-error" *ngIf="formError">
            Please fill in all fields before submitting.
          </div>

          <button class="al-btn-submit" (click)="onSubmit()">
            Register for a Thinking Challenge →
          </button>

          <div class="al-form-trust">
            <span class="al-trust-item">🔒 Secure</span>
            <span class="al-trust-item">✅ 100% Free</span>
            <span class="al-trust-item">📧 Instant Confirmation</span>
          </div>
        </ng-container>

      </div>
    </div>
  </div>
</section>

<!-- ══ TRUST STRIP ══ -->
<div class="al-trust-strip">
  <p class="al-trust-label">Trusted by families across England</p>
  <div class="al-trust-inner">
    <div class="al-trust-stat">
      <div class="al-trust-icon">👨‍👩‍👧</div>
      <div class="al-trust-text"><strong>4,800+</strong><span>Families registered</span></div>
    </div>
    <div class="al-trust-stat">
      <div class="al-trust-icon">🧠</div>
      <div class="al-trust-text"><strong>93%</strong><span>Report improved confidence after their consultation</span></div>
    </div>
    <div class="al-trust-stat">
      <div class="al-trust-icon">📊</div>
      <div class="al-trust-text"><strong>Years 3–11</strong><span>Every year group, one clear pathway</span></div>
    </div>
    <div class="al-trust-stat">
      <div class="al-trust-icon">⭐</div>
      <div class="al-trust-text"><strong>4.9 / 5</strong><span>Parent satisfaction score</span></div>
    </div>
  </div>
</div>

<!-- ══ SECTION 2: DIAGNOSTIC PILLARS ══ -->
<section class="al-section al-pillars-section">
  <div class="al-section-inner">
    <div class="al-section-head al-centered">
      <div class="al-label">Beyond Traditional Testing</div>
      <h2 class="al-heading">We Don't Just Measure<br/>What They Know. We Measure How They Think.</h2>
      <p class="al-sub">Most assessments tell you a score. Sehyog's assessments tell you exactly how your child reasons, solves problems, and applies knowledge in unfamiliar situations.</p>
    </div>
    <div class="al-rar-bar">
      <span class="al-rar-dot"></span>
      <span class="al-rar-text">
        Every family receives a
        <strong>Comprehensive Digital Performance Report &amp; Parent Consultation</strong>
      </span>
    </div>
    <div class="al-pillars-grid">
      <div class="al-pillar-card" [ngClass]="pillar.cls" *ngFor="let pillar of pillars">
        <div class="al-pillar-num">{{pillar.num}}</div>
        <h3 class="al-pillar-title">{{pillar.title}}</h3>
        <p class="al-pillar-body">{{pillar.body}}</p>
        <span class="al-pillar-tag">{{pillar.tag}}</span>
      </div>
    </div>
  </div>
</section>

<!-- ══ ASSESSMENT STRUCTURE — problem-list + mockup panel ══ -->
<section class="al-section al-structure-section">
  <div class="al-section-inner">
    <div class="al-structure-box">
      <div class="al-label al-label-gold al-label-onDark">⚡ Why It's Different</div>
      <h2 class="al-heading al-heading-white">One Challenge. Two Subjects. Full Picture.</h2>

      <!-- problem list — the pain-point framing, static copy -->
      <ul class="al-problem-list">
        <li>
          <span class="al-problem-icon">✕</span>
          <span>Timed multiple-choice tests reward guessing, not understanding</span>
        </li>
        <li>
          <span class="al-problem-icon">✕</span>
          <span>Generic scoring can't show <em>how</em> a child actually reasons</span>
        </li>
        <li>
          <span class="al-problem-icon">✕</span>
          <span>Most reports arrive weeks later, long after it's useful</span>
        </li>
      </ul>

      <p class="al-sub al-sub-faded al-structure-lede">A single, age-appropriate Mathematics &amp; English Thinking Challenge, curriculum-aligned and mapped to your child's exact year group.</p>

      <div class="al-structure-grid">
        <div class="al-structure-card" [ngClass]="sc.cls" *ngFor="let sc of structureCards">
          <div class="al-sc-num">{{sc.num}}</div>
          <h4 class="al-sc-title">{{sc.title}}</h4>
          <div class="al-sc-mark">{{sc.mark}}</div>
          <ul class="al-sc-topics">
            <li *ngFor="let t of sc.topics">{{t}}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ══ HOW IT WORKS — cards with mini mockup graphics ══ -->
<section class="al-section al-hiw-section" id="al-how-it-works">
  <div class="al-section-inner">
    <div class="al-section-head al-centered">
      <div class="al-label">How It Works</div>
      <h2 class="al-hiw-heading">
        Your Child's Learning Journey<br/>
        <span class="al-hiw-hi">in Six Simple Steps</span>
      </h2>
      <p class="al-sub al-sub-center">We've made the process frictionless — so you can focus on your child's progress, not the admin.</p>
    </div>

    <div class="al-steps-grid">
      <div class="al-step" *ngFor="let step of howSteps">
        <div class="al-step-top">
          <div class="al-step-num" [ngClass]="step.cls">{{step.num}}</div>
          <h5 class="al-step-title">{{step.title}}</h5>
        </div>
        <p class="al-step-body">{{step.body}}</p>
        <!-- decorative mini mockup — purely visual, cycles by position -->
        <div class="al-step-mock">
          <span class="al-step-mock-line al-line-1"></span>
          <span class="al-step-mock-line al-line-2"></span>
          <span class="al-step-mock-line al-line-3"></span>
        </div>
      </div>
    </div>

    <div class="al-webinar-card">
      <div class="al-webinar-inner">
        <div class="al-webinar-copy">
          <div class="al-webinar-free-badge">🎓 Free Consultation</div>
          <h3 class="al-webinar-title">1-to-1 Parent Consultation</h3>
          <div class="al-webinar-date">📅 Included free with every registration</div>
          <p class="al-webinar-desc">
            A dedicated session with an experienced Sehyog educator to walk through your child's
            report, thinking skills profile, and exactly what the data means for their next
            academic year.
          </p>
          <ul class="al-webinar-list">
            <li *ngFor="let item of consultationChecklist">{{item}}</li>
          </ul>
          <p class="al-webinar-note">*Cohort Places Are Strictly Limited</p>
        </div>
        <div class="al-webinar-action">
          <button class="al-webinar-btn" (click)="scrollToRegister()">Register Now →</button>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ══ WHAT YOUR CHILD WILL RECEIVE — cards with mini mockup graphics ══ -->
<section class="al-section al-receives-section">
  <div class="al-section-inner">
    <div class="al-section-head al-centered">
      <div class="al-label">What Your Family Will Receive</div>
      <h2 class="al-heading">More Than Just a Mark</h2>
      <p class="al-sub">Every registered family receives a rich results package within 48 hours — built on curriculum-aligned, evidence-based analysis, not generic automated scoring.</p>
    </div>
    <div class="al-receives-grid">
      <div class="al-receives-card" *ngFor="let rc of receivesCards">
        <div class="al-rc-icon">{{rc.icon}}</div>
        <div class="al-rc-text">
          <h5 class="al-rc-title">{{rc.title}}</h5>
          <p class="al-rc-body">{{rc.body}}</p>
        </div>
        <div class="al-rc-mock">
          <span class="al-rc-mock-dot"></span>
          <span class="al-rc-mock-dot"></span>
          <span class="al-rc-mock-dot"></span>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ══ CLOSING CTA BAND ══ -->
<section class="al-cta-band">
  <div class="al-cta-inner">
    <h2 class="al-cta-heading">Ready to see how your child really thinks?</h2>
    <p class="al-cta-sub">Free to enter. Results and consultation within 48 hours.</p>
    <button class="al-cta-btn" (click)="scrollToRegister()">Register for Your Free Assessment →</button>
  </div>
</section>

<!-- ══ FAQ ══ -->
<section class="al-section al-faq-section">
  <div class="al-section-inner">
    <div class="al-section-head al-centered">
      <div class="al-label">FAQs</div>
      <h2 class="al-heading">Your Questions, Answered</h2>
    </div>
    <div class="al-faq-list">
      <div class="al-faq-item" [ngClass]="{'al-faq-open': faq.open}" *ngFor="let faq of faqs; let i = index">
        <div class="al-faq-q" (click)="toggleFaq(i)">
          <span>{{faq.q}}</span>
          <span class="al-faq-arrow">▾</span>
        </div>
        <div class="al-faq-a" [style.maxHeight]="faq.open ? '240px' : '0px'">
          <div class="al-faq-a-inner">{{faq.a}}</div>
        </div>
      </div>
    </div>
  </div>
</section>